import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { Api } from '@core/api';
import { injectTSDI } from '@core/tsdi';

export function useLicensesExportStore() {
    const { corporateClient } = injectTSDI(Api);

    const list = useWrapRequest(
        async () => {
            const result =
                await corporateClient.support.licensesExportControllerList();
            return result.data ?? [];
        },
        { defaultData: [] }
    );

    const trigger = useWrapRequest(
        async (yearMonth: string) => {
            await corporateClient.support.licensesExportControllerRequest({
                year_month: yearMonth
            });
        },
        {
            successMessage: () =>
                'Export started — open “View exports” in a moment to download.'
        }
    );

    const refresh = () => {
        list.request([]);
    };

    return { list, trigger, refresh };
}
